import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";
import TextFieldGroup from "../../components/common/TextFieldGroup";
import TextAreaFieldGroup from "../../components/common/TextAreaFieldGroup";
import { Button, Col, Row } from "reactstrap";
import { USER_HOME_PATH } from "../../config/api-config";
import ContentBox from "../../components/common/ContentBox";
import SmallSpinner from "../../components/common/SmallSpinner";
import ReCAPTCHA from "react-google-recaptcha";

class Register extends Component {
	constructor() {
		super();
		this.state = {
			organization: "",
			name: "",
			email: "",
			password: "",
			password2: "",
			inventoryTonnes: "0",
			projectCount: "0",
			comment: "",
			errors: {},
			captchaToken: null,
		};

		this.recaptchaRef = createRef();
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleCaptchaChange = this.handleCaptchaChange.bind(this);
	}

	componentDidMount() {
		if (this.props.auth.isAuthenticated) {
			this.props.history.push(USER_HOME_PATH);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.errors) {
			this.setState({ errors: nextProps.errors });
		}
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	// reCAPTCHA handler
	handleCaptchaChange(token) {
		// Store the token; if null, captcha expired or errored
		this.setState({ captchaToken: token });
	}

	onSubmit(e) {
		e.preventDefault();

		// The submit button will already be disabled if captcha token isn't present
		// so this is just an additional safeguard
		if (!this.state.captchaToken) {
			return;
		}

		const newUser = {
			organization: this.state.organization,
			name: this.state.name,
			email: this.state.email,
			password: this.state.password,
			password2: this.state.password2,
			projects: this.state.projectCount,
			inventory: this.state.inventoryTonnes,
			comment: this.state.comment,
			captchaToken: this.state.captchaToken,
		};

		this.props.registerUser(newUser, this.props.history);
	}

	render() {
		const { errors, captchaToken } = this.state;
		const isButtonDisabled = this.props.auth.working || !captchaToken;

		return (
			<div style={{ justifyContent:'center', margin: '0 auto', width: '100%', maxWidth: '720px' }}>
				<ContentBox width="6" title="Create an Account">
					<p>
						Already have an account? <Link to="/login">Sign in</Link>
					</p>

					<form noValidate onSubmit={this.onSubmit}>
						{/* Your existing form fields remain unchanged */}
						<TextFieldGroup
							label="Organization"
							placeholder=""
							name="organization"
							type="text"
							value={this.state.organization}
							onChange={this.onChange}
							error={errors.organization}
						/>
						<TextFieldGroup
							label="Contact Person"
							placeholder=""
							name="name"
							type="text"
							value={this.state.name}
							onChange={this.onChange}
							error={errors.name}
						/>
						<TextFieldGroup
							label="Email"
							placeholder=""
							name="email"
							type="email"
							value={this.state.email}
							onChange={this.onChange}
							error={errors.email}
						/>
						<TextFieldGroup
							label="Password"
							placeholder=""
							name="password"
							type="password"
							value={this.state.password}
							onChange={this.onChange}
							error={errors.password}
						/>
						<TextFieldGroup
							label="Confirm Password"
							placeholder=""
							name="password2"
							type="password"
							value={this.state.password2}
							onChange={this.onChange}
							error={errors.password2}
						/>

						{/* Your existing form fields continue... */}
						<TextFieldGroup
							label="How many project do you want to register? Type 0 if you don't want to use projects."
							placeholder=""
							name="projectCount"
							type="text"
							value={this.state.projectCount}
							onChange={(e) => this.onChange(e)}
							error={errors.projects}
						/>

						<p>
							In addition to emission project database, the registry provides inventory
							and offsets functionalities, which allow clients to enter their corporate
							inventory and purchased offsets and track their carbon neutrality. The
							<i> GHG True-up Overview</i> functionality is equipped with visual analytics
							that will provide insights to emission reduction strategy. There is a
							one-time access fee to unlock these functionalities.
						</p>

						<TextFieldGroup
							id="inventory"
							label="What is your organization's most recent inventory (in t CO2e)? Type 0 if you don't want to use inventory functionalities."
							placeholder=""
							name="inventoryTonnes"
							type="text"
							value={this.state.inventoryTonnes}
							onChange={(e) => this.onChange(e)}
							error={errors.inventory}
						/>

						<TextAreaFieldGroup
							id="comment"
							label="Additional Comments"
							placeholder=""
							name="comment"
							type="text"
							value={this.state.comment}
							onChange={(e) => this.onChange(e)}
						/>

						{/* Add the reCAPTCHA component before the submit button */}
						<div className="recaptcha-container" style={{ margin: '20px 0' }}>
							<ReCAPTCHA
								ref={this.recaptchaRef}
								sitekey={this.props.apiKeys.keys.captchaKey}
								onChange={this.handleCaptchaChange}
							/>
						</div>

						<Row>
							<Col xs="6">
								<Button
									id="register"
									disabled={isButtonDisabled}
									color="primary"
									className="px-4"
								>
									<SmallSpinner width="20px" show={this.props.auth.working} />
									Register
								</Button>
							</Col>
						</Row>

						{!captchaToken && (
							<div style={{
								marginTop: '10px',
								fontSize: '0.85rem',
								color: '#666'
							}}>
								Please complete the reCAPTCHA verification to enable registration.
							</div>
						)}
					</form>
				</ContentBox>
			</div>
		);
	}
}

Register.propTypes = {
	registerUser: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	apiKeys: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	auth: state.auth,
	errors: state.errors,
	apiKeys: state.settings.apiKeys
});

export default connect(mapStateToProps, { registerUser })(withRouter(Register));
